// ────────────────────────────────────────────────────────────
// Mock-mode detection.
//
// Papersnap is built UI-first with mocked backend services.
// We're in mock mode whenever the Cognito env vars haven't been
// filled in. Once the staging stack is deployed and the real
// VITE_COGNITO_USER_POOL_ID lands in `.env`, mock mode auto-disables.
//
// Stores and lib modules check IS_MOCK_MODE to decide whether to:
//   • route through real Cognito / real API, or
//   • read/write localStorage with sample data
// ────────────────────────────────────────────────────────────

export const IS_MOCK_MODE = !import.meta.env.VITE_COGNITO_USER_POOL_ID
  || import.meta.env.VITE_COGNITO_USER_POOL_ID === ''

export const DEMO_USER = Object.freeze({
  userId: 'demo-user-001',
  email: 'demo@papersnap.io',
  isDemo: true,
})

// localStorage keys all share the `psnap:` prefix per Keelara convention.
export const STORAGE_KEYS = Object.freeze({
  auth: 'psnap:auth',
  plan: 'psnap:plan',
  quota: 'psnap:quota',
  documents: 'psnap:documents',
  theme: 'psnap:theme',
  hasSeenWelcome: 'psnap:hasSeenWelcome',
  customFields: 'psnap:customFields',
})

export function readJSON(key, fallback = null) {
  try {
    if (typeof localStorage === 'undefined') return fallback
    const raw = localStorage.getItem(key)
    return raw ? JSON.parse(raw) : fallback
  } catch {
    return fallback
  }
}

export function writeJSON(key, value) {
  try {
    if (typeof localStorage === 'undefined') return
    localStorage.setItem(key, JSON.stringify(value))
  } catch { /* quota / private-mode — ignore */ }
}

export function removeKey(key) {
  try {
    if (typeof localStorage === 'undefined') return
    localStorage.removeItem(key)
  } catch { /* ignore */ }
}
